import { createSlice, PayloadAction } from '@reduxjs/toolkit'

type ProductUtcOffsetSliceState = Record<string, number>

const initialState: ProductUtcOffsetSliceState = {}

const productsUtcOffsetSlice = createSlice({
    name: 'productsUtcOffsetSlice',
    initialState,
    reducers: {
        setProductUtcOffset: (
            state,
            action: PayloadAction<{ guid: string, data: number }>
        ) => {
            state[action.payload.guid] = action.payload.data
        },
    },
})

export const { actions: productsUtcOffsetActions } = productsUtcOffsetSlice
export const { reducer: productsUtcOffsetReducer } = productsUtcOffsetSlice
